import React, { FC } from 'react';
import { AddInput } from '../../../../../../lib/components/AddInput';
import { ListFooter } from '../../../../../../lib/components/List/ListFooter';
import { useClientConfigForm } from '../../../hooks/useClientConfigForm';

interface IProps {
	on_added: (v: string) => void;
}

export const AddIpRangeInput: FC<IProps> = ({ on_added }) => {
	const { validators } = useClientConfigForm();

	return (
		<ListFooter>
			<AddInput
				{...{
					on_added,
					validate: validators.range,
					format_value: (ip) => ip.replace(/ /g, '.').replace(/[^0-9.//]/g, ''),
				}}
			/>
		</ListFooter>
	);
};
